// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type PriceParity24CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const PriceParity24Circle: FC<PriceParity24CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path d="M11.606 16.25H8.044l1.781-4.133 1.781 4.133ZM23.956 16.25h-3.562l1.78-4.133 1.782 4.133ZM16 7.7c.27 0 .495.09.677.273a.92.92 0 0 1 .273.676c0 .27-.091.496-.273.678A.92.92 0 0 1 16 9.6a.92.92 0 0 1-.677-.273.922.922 0 0 1-.273-.678.92.92 0 0 1 .273-.676A.92.92 0 0 1 16 7.7Z" />
            <path
                d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0Zm0 5.8a2.76 2.76 0 0 0-1.662.534c-.49.356-.832.812-1.022 1.366H7.45v1.9h1.9L6.5 16.25c0 .792.325 1.464.974 2.019.649.554 1.433.83 2.351.83.918 0 1.702-.276 2.35-.83.65-.555.975-1.227.975-2.019L10.3 9.6h3.016a2.775 2.775 0 0 0 1.734 1.734V21.95H6.5v1.9h19v-1.9h-8.55V11.334A2.774 2.774 0 0 0 18.684 9.6H21.7l-2.85 6.65c0 .792.325 1.464.974 2.019.65.554 1.433.83 2.35.83.92 0 1.703-.276 2.352-.83.65-.555.974-1.227.974-2.019L22.65 9.6h1.9V7.7h-5.866a2.766 2.766 0 0 0-1.022-1.366A2.76 2.76 0 0 0 16 5.8Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default PriceParity24Circle;
